// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 70,
        paginationTypeAdvanced: true,
        activeScrollToTop: true,
        styleScrollToTop: "style1",
        /* Optional */
        //loadProductFirst: true,
      	activeLoadPreviousPage: true,
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
    'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',


    // Grid Template
    'productGridItemHtml':       '<li>' +
      '<a class="pinterest-link" target="_blank" href="//pinterest.com/pin/create/button/?url=https://foundrentalco.com{{itemUrl}}&amp;media={{itemThumbUrl}}&amp;description={{itemTitle}}">' +
      '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" style="width: 40px; height:40px;" xml:space="preserve">' +
      '<path style="fill:#939393;" d="M500.008,249.993C361.941,249.993,250,361.924,250,499.998c0,102.37,61.558,190.315,149.646,228.981' +
      'c-0.704-17.457-0.126-38.414,4.351-57.407c4.807-20.296,32.168-136.226,32.168-136.226s-7.988-15.963-7.988-39.557' +
		  'c0-37.047,21.474-64.718,48.216-64.718c22.739,0,33.726,17.08,33.726,37.533c0,22.86-14.579,57.053-22.078,88.723' +
		  'c-6.263,26.519,13.297,48.15,39.46,48.15c47.367,0,79.269-60.837,79.269-132.918c0-54.793-36.905-95.805-104.028-95.805' +
		  'c-75.836,0-123.081,56.555-123.081,119.726c0,21.78,6.422,37.142,16.481,49.034c4.625,5.463,5.268,7.661,3.593,13.934' +
		  'c-1.199,4.6-3.953,15.675-5.093,20.063c-1.665,6.332-6.795,8.595-12.518,6.257c-34.929-14.26-51.198-52.512-51.198-95.512' +
		  'c0-71.018,59.895-156.174,178.677-156.174c95.449,0,158.27,69.071,158.27,143.213c0,98.072-54.523,171.341-134.894,171.341' +
		  'c-26.991,0-52.38-14.591-61.077-31.162c0,0-14.514,57.601-17.588,68.724c-5.3,19.276-15.675,38.54-25.162,53.556' +
		  'c22.486,6.638,46.237,10.252,70.854,10.252C638.064,750.007,750,638.075,750,499.998C750,361.924,638.064,249.993,500.008,249.993z"/>' +
      '</svg></a>' +
                                    '<a href="{{itemUrl}}" class="grid-link card__wrapper card__wrapper--padding text-center">' +
                                        '<div class="image">' +
                                        '<img class="" src="{{itemThumbUrl}}"' +
                                                  ' data-src="{{itemThumbUrl}}"' +
                                               ' data-widths="[360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"'+
                                                      ' alt="{{itemTitle}}">' +
                                        '</div>' +
                                        '<br/><div class="product-info"><span>{{itemTitle}}</span>' +
                                        '<span class="rental-quantity" style="display:none;">qty: {{metaField2}}</span>' +
                                        '<span class="rental-price" style="display:none;">{{metaField}}</span>' +
                                        '<span class="'+ bcSfFilterConfig.custom.type + '">{{itemPrice}}</span></div>' +
                                    '</a>' +
                                 '</li>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',
  
    // Sorting Template
    'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="collection-sort__input">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100;
    data['variants'][0]['price_min'] = parseFloat(data['variants'][0]['price_min']) * 100;
    data['variants'][0]['compare_at_price_min'] = parseFloat(data['variants'][0]['compare_at_price_min']) * 100;
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }

    var metaField = '';
    if ( data.metafields['0']) {
      var metaFieldData = data.metafields['0']['value'];
      var metaField = JSON.parse(metaFieldData);

    }
   var metaField2 = '';
      if ( data.metafields['1']) {
      var metaField2 = data.metafields['1']['value'];
    }

    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Price
    var itemPriceHtml = '';
    if (data.title != '')  {
        itemPriceHtml += '<p class="grid-link__meta">';
        if (onSale) {
            itemPriceHtml += '<s class="grid-link__sale_price">' + this.formatMoney(data.compare_at_price_min) + '</s> ';
        }
        if (priceVaries) {
              itemPriceHtml += 'from ' + this.formatMoney(data.price_min);
        } else {
          itemPriceHtml += this.formatMoney(data.price_min);
        }
        itemPriceHtml += '</p>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  
    // Add onSale class
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  
    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add onSale Label
    var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add Metafields
    var itemMetaFieldHtml = metaField ? '$'+ metaField.amount : '';
    itemHtml = itemHtml.replace(/{{metaField}}/g, itemMetaFieldHtml);
     // Add Metafields
    var itemMetaField2Html = metaField2 ? metaField2 : '';
    itemHtml = itemHtml.replace(/{{metaField2}}/g, itemMetaField2Html);
  
    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
    // // Add Description
    // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    // // Truncate by word
    // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
    // // Truncate by character
    // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
    // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  // Avoid load products twice
  var self = this;  
  if (!self.getSettingValue('general.showPlaceholderProductList')) {
    jQ(self.selector.products).removeClass('bc-sf-product-loading');          
  }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {};

BCSfFilter.prototype.buildPaginationEvent = function(data) {
  switch (this.getSettingValue('general.paginationType')) {
    case 'default':
      this.buildDefaultPaginationEvent(data);
      break;
    case 'load_more':
      this.buildLoadMoreEvent(data);
      this.buildLoadPreviousPageEvent(data);
      break;
    default:
      this.buildInfiniteLoadingEvent(data);
      this.buildLoadPreviousPageEvent(data);
      break;
  }
};

BCSfFilter.prototype.isLoadPreviousPagePaginationType = function() {
  var self = this;
  return (self.isInfiniteLoadingPaginationType() || self.isLoadMorePaginationType()) && self.isAdvancedPaginationType() && self.getSettingValue('general.activeLoadPreviousPage') &&
  jQ(self.getSelector('btnLoadPreviousPageWrapperSelector')).length > 0;
};

// Build Infinite Loading event
BCSfFilter.prototype.buildInfiniteLoadingEvent = function(data) {
  var self = this;
  // Get total products
  var totalProduct = parseInt(data.total_product);
  /* Get limit per page */
  var limitPerPage = parseInt(self.getSettingValue('general.limit'));
  var currentPage = parseInt(self.queryParams.page);
  // Previous page data
  var bcSfFilterCurrentNextPage;
  if (self.isLoadPreviousPagePaginationType()) {
    bcSfFilterCurrentNextPage = parseInt(sessionStorage.getItem(self.getSettingValue('general.sessionStorageCurrentNextPage')));
  } else {
    bcSfFilterCurrentNextPage = currentPage;
  }
  
  
  /* Check if total products is greater than limit per page * curent page, do the infinite loading function, else do nothing */
  if (totalProduct > (limitPerPage * bcSfFilterCurrentNextPage)) {

    // Using scrolling to prevent callling onscroll twice
    var scrolling = 0;

    // onscroll event
    // When windown reaches the bottom of product list
    var scrollToBottom = false;

    // Pagination selector
    var paginationSelector = jQ(self.getSelector('bottomPagination'));

    // Check if pagination exists, do the infinite function
    if (paginationSelector.length > 0) {
      // When scroll down, do the infinite function
      jQ(window).scroll(function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Ignore load more if the product list is loading
        if (jQ(self.selector.products).hasClass('bc-sf-product-loading')) return false;        
        

        // get height of scroll bar
        var scrollbarHeight = jQ(window).height() * (jQ(window).height() / jQ(document).outerHeight());

        // get position of the pagination bottom
        var maxPos = parseInt(paginationSelector.offset().top);
        var maxScroll = parseInt(jQ(window).scrollTop()) + scrollbarHeight + self.getSettingValue('general.positionShowInfiniteLoading');
        if ((jQ(window).scrollTop() + jQ(window).height() + scrollbarHeight) >= jQ(document).outerHeight() - 100) {
          scrollToBottom = true;
        }

        // Begin loading more products
        if (scrolling == 0 && data.products.length > 0) {
          if (maxScroll >= maxPos || (maxScroll < maxPos && scrollToBottom)) {
            // Show Loading
            self.showLoadMoreLoading();

            // Prevent scrolling twice
            scrolling = 1;
            
            // Previous page data
            if (self.isLoadPreviousPagePaginationType()) {
              bcSfFilterCurrentNextPage = parseInt(sessionStorage.getItem(self.getSettingValue('general.sessionStorageCurrentNextPage')));
            } else {
              bcSfFilterCurrentNextPage = currentPage;
            }

            // Next page
            bcSfFilterCurrentNextPage++;
            

            // Send request if current page is smaller or equal to total number of pages
            var totalPage = Math.ceil(data.total_product / self.getSettingValue('general.limit'));
            // console.log(currentPage, totalPage);
            if (bcSfFilterCurrentNextPage <= totalPage) {
              self.internalClick = true;
              self.queryParams.limit = self.getSettingValue('general.limit');
              self.queryParams.page = bcSfFilterCurrentNextPage;
              
              // Avoid load twice
              if (!self.getSettingValue('general.showPlaceholderProductList')) {
                jQ(self.selector.products).addClass('bc-sf-product-loading');          
              }
              
              // Append "page" param to url
              // Used to Scroll to the previous position after returning from Product page
              if (self.getSettingValue('general.paginationTypeAdvanced')) {
                var newUrl = self.buildToolbarLink('page', getCurrPage() , bcSfFilterCurrentNextPage);
                // If the previous page feature is activated
                if (self.isLoadPreviousPagePaginationType()) {
                  // Save the previous page data                  
                  sessionStorage.setItem(self.getSettingValue('general.sessionStorageCurrentNextPage'), bcSfFilterCurrentNextPage);
                  sessionStorage.setItem(self.getSettingValue('general.sessionStoragePreviousPageEvent'), 0);
                }
                self.onChangeData(newUrl, 'page');
              } else {
                self.getFilterData('page');
              }
            }
          }
        }
      });
    }
  }
};

/* Parse URL parameters */
function parse_query_string(query) {
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof query_string[key] === "undefined") {
      query_string[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof query_string[key] === "string") {
      var arr = [query_string[key], decodeURIComponent(value)];
      query_string[key] = arr;
      // If third or later entry with this name
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
}

/* Get the current page from address */
function getCurrPage() {
  var url = parse_query_string(window.location.search.substring(1));
  return url.page;
}

BCSfFilter.prototype.buildAll = function(data, isBuildFilterTree, eventType) {
  var self = this;
    // Prepare data
    var paginationSelector = this.selector.pagination;
    var totalProduct = data.total_product;

    if (isBuildFilterTree === true && data.hasOwnProperty('filter')) {
        // Build Filter Tree
        this.buildFilterTree(data.filter.options);
        // Build Filter Selections
        if (this.getSettingValue('general.showRefineBy')) {
            this.buildFilterSelection(data);
        }
        // Customize Filter tree on mobile
        this.buildFilterTreeMobile();
        // Build Filter Tree Button for Mobile
        this.buildFilterTreeMobileButton(data);
        // Build events: clear filter option, clear all filter options and toggle on title
        this.buildAdditionalFilterEvent();
    }
    if (totalProduct > 0) {
        // Build Product List
        this.buildProductList(data.products, eventType);
        // Build Pagination
        var paginationType = this.getSettingValue('general.paginationType');
        if (paginationType == 'default') {
            this.buildPagination(totalProduct);
        } else {
            jQ(paginationSelector).empty();
            if (self.isLoadMorePaginationType()) {
              // Build load more button
              this.buildLoadMoreButton(totalProduct);
              // Build previous button
              this.buildLoadPreviousButton(totalProduct, eventType);
            } else if (self.isInfiniteLoadingPaginationType()) {              
              // Build previous button
              this.buildLoadPreviousButton(totalProduct, eventType);
            }
        }
        // Build Toolbar
        this.buildToolbar();
        // Build Toolbar Event (Pagination, Sorting,...)
        this.buildToolbarEvent(data);
        // Hide Error Notification after build succesfully
        jQ(this.selector.filterWrapper).show();
        var topNotificationSelector = this.selector.topNotification;
        if (jQ(topNotificationSelector).length > 0) jQ(topNotificationSelector).empty();
    }

    // Show Products & Pagination after building (also used for Fallback)
    jQ(this.selector.products).removeAttr('data-bc-sort');
    jQ(paginationSelector).show();

    // Build Additional Elements
    this.buildAdditionalElements(data, eventType);

    // Build Scroll to Top
    this.buildScrollToTop();

    // Scroll to previous position when going back from product page
    this.scrollBackPositionHistoryBack();

    // Build Page information
    if (eventType == 'collection') this.buildPageInfo(data);

    // Build Search
    if (this.isSearchPage()) {
        this.buildSEOTitle(data);
        this.buildSearchResultHeader(data);
        this.buildSearchResultNumber(data);
    }

    // Add Meta tag to exclude pages with filter params from Goolge crawl
    this.buildRobotsMetaTag(data);

    this.selectFilter = false;
};


/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
